import Dropzone from "dropzone"		;

$( function() {
  	const elements = document.querySelectorAll(".dropzone");

	  elements.forEach((element) => {
	    new Dropzone(element,	{
									url			: element.action	,
									paramName	: "file"			,
									maxFilesize	: 0.2		
							    });
	  });
});